import React from 'react';
import './ServicesGrid.css';

const items = [
  {
    title: 'Strategieberatung & Gestaltungsberatung',
    text: 'Wir gestalten maßgeschneiderte Lösungen – von steuereffizienten Firmen- und Beteiligungsstrukturen über optimierte Transaktionen bis zur strategischen Nachfolgeplanung - mit besonderem Fokus auf Immobilien.',
    icon: '/img/king.svg',
  },
  {
    title: 'Steuerberatung',
    text: 'Laufende steuerliche Betreuung mit Weitblick, Effizienz und unternehmerischem Verständnis.',
    icon: '/img/paragraph.svg',
  },
  {
    title: 'Jahresabschlüsse & Steuererklärungen',
    text: 'Abgestimmt mit den individuellen Abschluss- und Unternehmenszielen - sei es die Abgabenoptimierung, Gewinnmaximierung oder Bonitätsverbesserung.',
    icon: '/img/timer.svg',
  },
  {
    title: 'Buchhaltung',
    text: 'Aktuell, übersichtlich und digital – als stabiles Fundament für unternehmerische Entscheidungen.',
    icon: '/img/archive.svg',
  },
  {
    title: 'Lohnverrechnung',
    text: 'Effizient, verlässlich, und auf dem neuesten Stand – für eine reibungslose und korrekte Abwicklung der Personalabrechnungen.',
    icon: '/img/bill.svg',
  },
  {
    title: 'Betriebswirtschaftliche Beratung',
    text: 'Wir begleiten bei Investitionsentscheidungen, Finanzierungsprozessen und strategischer Planung.',
    icon: '/img/percentage.svg',
    size: 'sm',
  },
];

const ServicesGrid = () => {
  return (
    <section className="services reveal" id="services">
      <div className="services__inner">
        <h2 className="services__title">Leistungen</h2>
        <div className="services__grid">
          {items.map((s) => (
            <article key={s.title} className="service-card reveal">
              <div className={`service-card__icon ${s.size === 'sm' ? 'service-card__icon--sm' : ''}`} aria-hidden>
                <img src={s.icon} alt="" />
              </div>
              <h4 className="service-card__title">{s.title}</h4>
              <div className="service-card__divider" />
              <p className="service-card__text">{s.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;


